export const WIDTH_XS = 320
export const WIDTH_SM = 576
export const WIDTH_MD = 768
export const WIDTH_LG = 992
export const WIDTH_XL = 1200
export const WIDTH_XXL = 1600
